import React from 'react';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';

class Activities extends React.Component {
  constructor(props) {
    super(props);
    this.state = { organisation: null };
  };

  render = () => {
    return (
      <div>
        <Typography variant="subheading" gutterBottom>
          Activities
        </Typography>
        <Divider />
        <ListItem>
          N/A
        </ListItem>
      </div>
    );
  };
}

export default Activities;



// WEBPACK FOOTER //
// ./src/components/Organisations/Activities.js